import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const ShippingPaidCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipping paid by customer",
    cell: (row) => {
      return `$${row.totalShippingCost.amount}`;
    },
  };
